import React from 'react';
import {
    importOLXAutosLandingPage,
    importHowToSellPage,
    importRequiredDocumentsPage,
    importFAQPage,
    importAboutUsPage
} from './olxautosFlows';
import LazyUniversalComponent from 'Components/LazyUniversalComponent/LazyUniversalComponent';
import { onEnterCxeRoutes, onEnterValuation, onSetLanguageOnboardingFlag } from '../routes/legacyRouterHooks';
import { checkFeature, getConditionalRoute, movedPermanently } from 'Helpers/routeHelper';
import { VALUATION_FLOW_ROUTE, SELL_OLD_CAR_ROUTE } from '../olxautos/constants/layout';

const cxeDrivenRoutes = (asyncCompLoader, config) => {
    const paths = config.landingPageRoutes
        ? Object.entries(config.landingPageRoutes).map(keyValue => keyValue[1])
        : [];

    /**
     * Only enable route for india
     */
    if (config?.olxAutos?.isHandleSeoLink) {
        paths.push(`${SELL_OLD_CAR_ROUTE}/*`);
    }

    if (config.buyerIntentRoute) {
        paths.push(config.buyerIntentRoute);
    }
    if (config.sellThematicPages?.showSellThematicPages) {
        const sellOrganicRoute = config.landingPageRoutes && config.landingPageRoutes['sell-organic'];
        const sellPPCRoute = config.landingPageRoutes && config.landingPageRoutes['sell-ppc'];
        const sellPPC2Route = config.landingPageRoutes && config.landingPageRoutes['sell-ppc-2'];

        if (sellOrganicRoute) {
            paths.push(sellOrganicRoute);
        }

        if (sellPPCRoute) {
            paths.push(sellPPCRoute);
        }

        if (sellPPC2Route) {
            paths.push(sellPPC2Route);
        }
    }
    return paths.map(path => {
        return {
            path,
            element: <LazyUniversalComponent
                onEnter={ onEnterCxeRoutes }
                onLeave={ onSetLanguageOnboardingFlag }
                component={ importOLXAutosLandingPage() }
                asyncComponentLoader={ asyncCompLoader }
            />,
            children: [{
                path: ':seoTheme'
            }],
            unsafeOnEnter: onEnterCxeRoutes
        };
    });
};

const getRequiredDocumentsRoute = (asyncCompLoader, config) => {
    if (
        !config.requiredDocumentsPath
        || typeof config.requiredDocumentsPath !== 'string'
    ) {
        return [];
    }

    return [
        {
            path: config.requiredDocumentsPath,
            element: <LazyUniversalComponent
                component={ importRequiredDocumentsPage() }
                asyncComponentLoader={ asyncCompLoader }
            />
        }
    ];
};

const getFaqRoute = (asyncCompLoader, config) => {
    if (!config.faqPath || typeof config.faqPath !== 'string') {
        return [];
    }
    return [
        {
            path: `/${config.faqPath}`,
            unsafeOnEnter: checkFeature(config?.olxAutos?.isMigratedToPanamera),
            element: <LazyUniversalComponent
                component={ importFAQPage() }
                asyncComponentLoader={ asyncCompLoader }
            />
        }
    ];
};

const olxAutosRoutes = (asyncCompLoader, config) => [
    ...cxeDrivenRoutes(asyncCompLoader, config),
    {
        /**
         * Only enable all route for india
         */
        path: config?.olxAutos?.isHandleSeoLink ? `${VALUATION_FLOW_ROUTE}/${SELL_OLD_CAR_ROUTE}/*` : `${VALUATION_FLOW_ROUTE}`,
        unsafeOnEnter: onEnterValuation,
        element: <LazyUniversalComponent
            component={ importOLXAutosLandingPage() }
            onEnter={ onEnterValuation }
            onLeave={ onSetLanguageOnboardingFlag }
            asyncComponentLoader={ asyncCompLoader }
        />
    },
    {
        path: `/${config.howToSellPagePath}`,
        element: <LazyUniversalComponent
            component={ importHowToSellPage() }
            onEnter={ checkFeature(config && config.olxAutos && config.olxAutos.isMXCL) }
            onLeave={ onSetLanguageOnboardingFlag }
            asyncComponentLoader={ asyncCompLoader }
        />,
        unsafeOnEnter: checkFeature(config && config.olxAutos && config.olxAutos.isMXCL)
    },
    ...getConditionalRoute({
        path: `/${config.termsAndConditions}`,
        unsafeOnEnter: (_, replace) => {
            replace({
                pathname: config.staticAssets + config.redirectionTermsAndConditions,
                state: movedPermanently()
            });
        }
    }, config.termsAndConditions),
    ...getConditionalRoute(
        {
            path: `/${config.aboutUs}`,
            element: <LazyUniversalComponent
                component={ importAboutUsPage() }
                asyncComponentLoader={ asyncCompLoader }
            />
        }, config && config.olxAutos && config.olxAutos.isMXCL),
    ...getRequiredDocumentsRoute(asyncCompLoader, config),
    {
        path: 'aviso-de-privacidad',
        unsafeOnEnter: (_, replace) => {
            replace({
                pathname: config.staticAssets + config.redirectionPrivacyPolicy,
                state: movedPermanently()
            });
        }
    },
    ...getFaqRoute(asyncCompLoader, config)
];

export default olxAutosRoutes;
